<template>
    <div>
        <template v-if="field.range">
        </template>
        <template v-else>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            readonly
            min-width="290px"
          >

            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="show_value0"
                :label="field.description"
                prepend-icon="event"
                readonly
                clearable
                v-on="on"
                style="max-width: 250px;"
              ></v-text-field>


            </template>
            <v-time-picker
              format="24hr"
              v-model="field.value" @input="select_cal(0)"></v-time-picker>

          </v-menu>
        </template>
    </div>
</template>
<script>
export default {
    props:["field",'filter_change'],
    select_cal(idx){
        //this.calc_values();
        this.menu[idx] = false;
        this.set_need_empty();
        if(idx==0){
            this.field.value_low=this.dat_value0;
        }
        else{
            this.field.value_hi=this.dat_value1;
        }
        let values=[];

    },
    data(){
        return {
            value0:'',
            value1:'',
            show_value0:'',
            show_value1:'',
            //show_calendar: false,
            menu: [false,false],
            modal: [false,false],
            need_empty:[false,false]
        }
    }
}
</script>